var map = {
	"./CartTotalExtensions": 27623,
	"./CartTotalExtensions.tsx": 27623,
	"./CheckoutShippingExtensions": 81782,
	"./CheckoutShippingExtensions.ts": 81782,
	"./CommonComponentsExtensions": 50220,
	"./CommonComponentsExtensions.ts": 50220,
	"./OrderDetailsExtensions": 12478,
	"./OrderDetailsExtensions.ts": 12478,
	"./OrderHistoryExtensions": 8091,
	"./OrderHistoryExtensions.ts": 8091,
	"./PageBreadCrumbsExtensions": 22716,
	"./PageBreadCrumbsExtensions.tsx": 22716,
	"./ProductAttributes": 80462,
	"./ProductAttributes.ts": 80462,
	"./ProductCarouselExtensions": 10791,
	"./ProductCarouselExtensions.ts": 10791,
	"./ProductDetailsAvailabilityExtensions": 47478,
	"./ProductDetailsAvailabilityExtensions.tsx": 47478,
	"./ProductDetailsPriceExtensions": 4332,
	"./ProductDetailsPriceExtensions.tsx": 4332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38720;